import styles from './Login.module.scss';

import { Button, Loader } from '@/components';
import { useNavigation } from '@/hooks/useNavigation';
import { PAGE } from '@/modules/page/routes';
import { useStore } from '@/store';
import { activateAuthTokenByGoogle } from '@/utils';

import { useGoogleLogin } from '@react-oauth/google';
import { useState } from 'react';

export const LoginButton = ({
  children,
  afterLoginCallback,
}: {
  children: React.ReactNode;
  afterLoginCallback?: () => void;
}) => {
  const { accountStore } = useStore();
  const { currentPage, goTo } = useNavigation();
  const [isLoading, setIsLoading] = useState(false);

  const googleLogin = useGoogleLogin({
    onSuccess: async ({ code }) => {
      setIsLoading(true);
      await activateAuthTokenByGoogle(code, accountStore);
      await accountStore.getAccountData();
      if (currentPage === PAGE.PROFILE_ID) {
        setTimeout(() => {
          goTo(PAGE.PROFILE_ID, { id: accountStore.accountData._id || 'me' });
        }, 100);
      }
      if (afterLoginCallback) afterLoginCallback();
      setTimeout(() => {
        setIsLoading(false);
      }, 300);
    },
    flow: 'auth-code',
  });

  return (
    <Button
      className={styles.button}
      onClick={googleLogin}
      disabled={isLoading}
    >
      {isLoading ? <Loader inButton /> : children}
    </Button>
  );
};
